import { render } from "./Prefs.vue?vue&type=template&id=1c73a239&scoped=true&ts=true"
import script from "./Prefs.vue?vue&type=script&lang=ts"
export * from "./Prefs.vue?vue&type=script&lang=ts"

import "./Prefs.vue?vue&type=style&index=0&id=1c73a239&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c73a239"]])

export default __exports__